import { render, staticRenderFns } from "./ItemsTableImage.vue?vue&type=template&id=7a90a334&scoped=true&"
import script from "./ItemsTableImage.vue?vue&type=script&lang=js&"
export * from "./ItemsTableImage.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTableImage.vue?vue&type=style&index=0&id=7a90a334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a90a334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDialog,VImg})
